export enum SearchOption {
  INSTITUTION = "INSTITUTION",
  FUND = "FUND",
  FUND_FA_ONLY = "FUND_FA_ONLY",
  FINDING_AID = "FINDING_AID",
  ARCH_DESC = "ARCH_DESC",
  ARCH_DESC_DAO_ONLY = "ARCH_DESC_DAO_ONLY",
  ENTITY = "ENTITY",
  ORIGINATOR = "ORIGINATOR",
}
